export default defineNuxtPlugin((nuxtApp) => {
  function scrollMeTo({ el, offset = 0 }) {
    const element = document.getElementById(el.replace('#', ''))
    if (!element) {
      return
    }
    const y = element.getBoundingClientRect().top + window.scrollY
    scrollTo({ top: y + offset, behavior: 'smooth' })
  }
  nuxtApp.vueApp.directive('scroll-to', {
    mounted (el, binding) {
      // console.log('->>!!!!!>>>>>>>vScrollTo', el, binding)
      el.addEventListener('click', (e) => {
        scrollMeTo(binding.value)
      })
    },
    getSSRProps (binding, vnode) {
      // you can provide SSR-specific props here
      return {}
    }
  })
})
